var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Type } from 'class-transformer';
import { IsArray, IsOptional, IsString, IsUrl, ValidateNested } from 'class-validator';
export class Links {
}
__decorate([
    IsUrl({ require_protocol: true }),
    IsOptional(),
    __metadata("design:type", String)
], Links.prototype, "twitter", void 0);
__decorate([
    IsOptional(),
    __metadata("design:type", String)
], Links.prototype, "linkedin", void 0);
__decorate([
    IsUrl({ require_protocol: true }),
    IsOptional(),
    __metadata("design:type", String)
], Links.prototype, "github", void 0);
__decorate([
    IsUrl({ require_protocol: true }),
    IsOptional(),
    __metadata("design:type", String)
], Links.prototype, "stackoverflow", void 0);
__decorate([
    IsArray(),
    ValidateNested({ each: true }),
    Type(() => OtherLink),
    __metadata("design:type", Array)
], Links.prototype, "others", void 0);
export class OtherLink {
}
__decorate([
    IsUrl({ require_protocol: true }),
    __metadata("design:type", String)
], OtherLink.prototype, "url", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], OtherLink.prototype, "desc", void 0);
//# sourceMappingURL=links.js.map